import type { CSSProperties } from 'react';
import type { ThemeProviderContextValue } from '../ThemeProviderContext';

type GetCustomStylesProps = {
  brand: ThemeProviderContextValue['customBrand'];
};

export function getCustomBrandStyles({ brand }: GetCustomStylesProps) {
  const brandStyles = brand
    ? {
        '--colors-brand-checkbox-svg': brand.checkboxSvgToken,
        '--colors-brand-dark': brand.dark,
        '--colors-brand-darker': brand.darker,
        '--colors-brand-icon-contrast': brand.iconContrastToken,
        '--colors-brand-light': brand.light,
        '--colors-brand-lighter': brand.lighter,
        '--colors-brand-primary': brand.primary,
        '--colors-brand-primary-alpha-low': brand.primaryAlphaLow,
        '--colors-brand-primary-alpha-medium': brand.primaryAlphaMedium,
        '--colors-brand-text-contrast': brand.textContrastToken,
      }
    : {};

  return {
    ...brandStyles,
  } as CSSProperties;
}

export function getAccentNeutralStyles({
  accentNeutralColors,
}: Pick<ThemeProviderContextValue, 'accentNeutralColors'>): CSSProperties {
  return (
    accentNeutralColors
      ? {
          '--colors-background-panel': accentNeutralColors.backgroundPanel,
          '--colors-background-primary': accentNeutralColors.backgroundPrimary,
          '--colors-background-secondary':
            accentNeutralColors.backgroundSecondary,
          '--colors-components-popover-background':
            accentNeutralColors.backgroundSecondary,
          '--colors-components-popover-border':
            accentNeutralColors.backgroundSecondary,
          '--colors-components-player-interactive-text-automated':
            accentNeutralColors.playerTitleToken,
          '--colors-background-interactive-activated-solid':
            accentNeutralColors.backgroundActivated,
        }
      : {}
  ) as CSSProperties;
}

export function getCustomStyles({
  customBrand,
  accentNeutralBrand,
  accentNeutralColors,
}: Pick<
  ThemeProviderContextValue,
  'customBrand' | 'accentNeutralBrand' | 'accentNeutralColors'
>): CSSProperties {
  const brand = accentNeutralBrand || customBrand;
  const brandStyles = getCustomBrandStyles({ brand });
  const accentNeutralStyles = getAccentNeutralStyles({ accentNeutralColors });
  return {
    ...brandStyles,
    ...accentNeutralStyles,
  };
}
